import React from 'react';
import T from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
  changeInput,
  setSelectedDraftScheduleStep,
} from '@dmi/shared/redux/Payments/FlexDraft/actions';
import { FLEX_DRAFT_SCHEDULE_BI_WEEKLY } from '@dmi/shared/redux/Payments/FlexDraft/constants';
import makeSelectFlexDraft, { selectForm } from '@dmi/shared/redux/Payments/FlexDraft/selectors';

import {
  ScheduleBiWeekly,
  ScheduleSemiMonthly,
} from '../../../../components/Payments/FlexDraft/EditSchedule';

const ScheduleSet = ({
  dispatchChangeInput,
  dispatchSetSelectedDraftScheduleStep,
  formValuesScheduleBiWeekly,
  formValuesScheduleSemiMonthly,
  navigation,
  selectedDraftScheduleStep,
}) => {
  const ViewToRender = selectedDraftScheduleStep === FLEX_DRAFT_SCHEDULE_BI_WEEKLY
    ? ScheduleBiWeekly
    : ScheduleSemiMonthly;

  const formValues = selectedDraftScheduleStep === FLEX_DRAFT_SCHEDULE_BI_WEEKLY
    ? formValuesScheduleBiWeekly
    : formValuesScheduleSemiMonthly;

  return (
    <ViewToRender
      dispatchChangeInput={dispatchChangeInput}
      dispatchSetSelectedDraftScheduleStep={dispatchSetSelectedDraftScheduleStep}
      formValues={formValues}
      navigation={navigation}
    />
  );
};

ScheduleSet.propTypes = {
  dispatchChangeInput: T.func.isRequired,
  dispatchSetSelectedDraftScheduleStep: T.func.isRequired,
  formValuesScheduleBiWeekly: T.object.isRequired,
  formValuesScheduleSemiMonthly: T.object.isRequired,
  navigation: T.object.isRequired,
  selectedDraftScheduleStep: T.string.isRequired,
};

const mapStateToProps = createStructuredSelector({
  formValuesScheduleBiWeekly: selectForm('scheduleBiWeekly'),
  formValuesScheduleSemiMonthly: selectForm('scheduleSemiMonthly'),
  selectedDraftScheduleStep: makeSelectFlexDraft('selectedDraftScheduleStep'),
});

const mapDispatchToProps = (dispatch) => ({
  dispatchChangeInput: (payload) => dispatch(changeInput(payload)),
  dispatchSetSelectedDraftScheduleStep: ({ step }) =>
    dispatch(setSelectedDraftScheduleStep({ step })),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ScheduleSet);
